export default {
    color: {
        info: '#00B6F0',
        white: '#fff',
        purple: '#D7E0F9',
        grey: 'silver'
    }
}